module.exports = __webpack_public_path__ + "img/close.a8050e29.svg";